import $ from "jquery"

$(".btn-android").addClass("active")

$(".development-updates-btn-item").on("click", function () {
  $(".development-updates-btn-item").removeClass("active")

  $(this).addClass("active")

  $(".development-updates-content").hide()

  var activeTab = $(this).attr("href")

  $(activeTab).fadeIn()

  return false
})

// Development Update Button See All
$(".development-updates-btn-item").on("click", function () {
  const hrefValue = $(this).attr("href")
  const newHref = hrefValue.substring(11)
  $("#button-see-all").attr("href", "/category/" + newHref)
})
